<style lang="scss" scoped>
.medical-history {
  padding: 0 10px;
}
</style>

<template>
  <article
    v-if="evaluations.length > 0"
    class="medical-history"
  >
    <h5
      v-if="!isMedicalHistoryVisible.status"
      class="text-center"
    >
      {{ isMedicalHistoryVisible.msg }}
    </h5>

    <h3
      v-if="!appointmentStarted && localEvaluations.length === 0"
      class="text-center"
    >
      Este paciente ainda nío realizou consultas.
    </h3>

    <template v-if="localEvaluations.length > 0 && isMedicalHistoryVisible.status">
      <medical-history-evaluation
        v-for="(evaluation, index) in localEvaluations"
        :key="`medical-history-evaluation-${index}`"
        :is-medical-history-visible="isMedicalHistoryVisible"
        :has-appointment="hasAppointment"
        :evaluation="evaluation"
        :doctor="doctor"
        :patient="patient"
      />
    </template>
  </article>
</template>

<script>
import MedicalHistoryEvaluation from './medicalHistoryEvaluation.vue'

export default {
  name: 'Evaluations',

  components: {
    MedicalHistoryEvaluation
  },

  props: {
    appointmentStarted: {
      type: Boolean,
      default: () => false
    },

    hasAppointment: {
      type: Boolean,
      default: () => false
    },

    doctor: {
      type: Object,
      required: true
    },

    patient: {
      type: Object,
      required: true
    },

    isMedicalHistoryVisible: {
      type: Object,
      default: () => ({ msg: null, status: true })
    },

    selectedComponent: {
      type: String,
      required: false
    },

    evaluations: {
      type: Array,
      default: () => []
    }
  },

  computed: {
    localEvaluations () {
      return this.evaluations.filter((evaluation) => {
        return evaluation['medical_consultation_start'] && evaluation['medical_consultation_finish']
      })
    }
  }
}
</script>
